export default "__VITE_ASSET__D9QwOJg2__"